import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-year-selector',
  templateUrl: './year-selector.component.html',
  styleUrls: ['./year-selector.component.scss']
})
export class YearSelectorComponent implements  OnInit  {

  constructor(private cdref: ChangeDetectorRef) {
    this.getYears();
  }

  ngOnInit(): void {
    setTimeout(()=> {
      this.setValue(this.currentYear);
    }, 0);
  }

  @Output() selectedValueChange = new EventEmitter<number>();

  currentYear = (new Date()).getFullYear();
  years: number[] = new Array<number> ();

  @Input() selectedValue: number;
  @Input() placeHolder: string = '';
  @Input() dataSize: number = 7;
  @Input() required: boolean;


  getYears(){
    const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    this.years = range(this.currentYear, this.currentYear - 2, -1);
  }

  setValue(value: number){
    this.selectedValue = value;
    this.selectedValueChange.emit(this.selectedValue);
  }

  onSelectedValueChange(event){
    this.setValue(event);
  }


}
